module.exports = __webpack_public_path__ + "media/images/lb/807-f9d2bc6a21bfc97f712e4ff88ff9b5fe.svg";